import React from 'react'
import { ApplicationPage } from '.'
import { ApplicantType, ApplicationType } from 'shared'

export default function PrivateLoanPage(){
    return <ApplicationPage type={ApplicationType.Loan} applicantType={ApplicantType.Private} />
}